import { Stack, Typography } from '@mui/material';
import { type BackupVault } from '@repo/api-gw-sdk';

import BackupVaultCard from './backupVaultCard';

export const BackupVaultSelection = ({
  onSelect,
  selectedVaults,
  loading,
  vaults,
  shouldWrap = true,
}: {
  onSelect: (vault: BackupVault) => void;
  selectedVaults: string[];
  loading?: boolean;
  vaults?: BackupVault[];
  shouldWrap?: boolean;
}) => {
  return (
    <Stack direction='row' gap='24px' flexWrap={shouldWrap ? 'wrap' : 'nowrap'}>
      {loading ? (
        [...Array(3)].map((_, index) => (
          <BackupVaultCard
            key={index}
            loading={true}
            style={{ width: '320px', height: '184px' }}
            editable={false}
          />
        ))
      ) : vaults?.length ? (
        vaults?.map((vault, idx) => (
          <BackupVaultCard
            style={{
              width: '320px',
              height: '184px',
            }}
            key={idx}
            data={vault}
            editable={false}
            onClick={onSelect}
            selected={selectedVaults.includes(vault.id)}
          />
        ))
      ) : (
        <VaultsEmptyState />
      )}
    </Stack>
  );
};

const VaultsEmptyState = () => {
  return (
    <Stack
      width='100%'
      alignItems='center'
      justifyContent='center'
      marginY='80px'
      spacing='24px'
    >
      <Typography variant='h4' align='center'>
        No vaults found
      </Typography>
    </Stack>
  );
};
